// Palette colors based off of Fluent definitions: https://developer.microsoft.com/en-us/fluentui#/styles/web/colors/theme-slots

import { ThemeColorPaletteSlots } from './ThemingProperties';

export const ThemeColorPaletteShared = {
  PinkRed10: `var(${ThemeColorPaletteSlots.PinkRed10}, #750b1c)`,
  Red20: `var(${ThemeColorPaletteSlots.Red20}, #a4262c)`,
  Red10: `var(${ThemeColorPaletteSlots.Red10}, #d13438)`,
  RedOrange10: `var(${ThemeColorPaletteSlots.RedOrange10}, #da3b01)`,
  Orange30: `var(${ThemeColorPaletteSlots.Orange30},#8e562e)`,
  Orange20: `var(${ThemeColorPaletteSlots.Orange20},#ca5010)`,
  Orange10: `var(${ThemeColorPaletteSlots.Orange10},#ffaa44)`,
  Yellow20: `var(${ThemeColorPaletteSlots.Yellow20},#986f0B)`,
  Yellow10: `var(${ThemeColorPaletteSlots.Yellow10},#fce100)`,
  OrangeYellow20: `var(${ThemeColorPaletteSlots.OrangeYellow20},#986f0b)`,
  OrangeYellow10: `var(${ThemeColorPaletteSlots.OrangeYellow10},#c19c00)`,
  YellowGreen10: `var(${ThemeColorPaletteSlots.YellowGreen10},#8cbd18)`,
  Green20: `var(${ThemeColorPaletteSlots.Green20},#0b6a0b)`,
  Green10: `var(${ThemeColorPaletteSlots.Green10},#498205)`,
  GreenCyan10: `var(${ThemeColorPaletteSlots.GreenCyan10},#00ad56)`,
  Cyan30: `var(${ThemeColorPaletteSlots.Cyan30},#005b70)`,
  Cyan20: `var(${ThemeColorPaletteSlots.Cyan20},#038387)`,
  Cyan10: `var(${ThemeColorPaletteSlots.Cyan10},#00b7c3)`,
  CyanBlue20: `var(${ThemeColorPaletteSlots.CyanBlue20},#004e8c)`,
  CyanBlue10: `var(${ThemeColorPaletteSlots.CyanBlue10},#0078d4)`,
  Blue10: `var(${ThemeColorPaletteSlots.Blue10},#4f6bed)`,
  BlueMagenta30: `var(${ThemeColorPaletteSlots.BlueMagenta30},#5c2e91)`,
  BlueMagenta20: `var(${ThemeColorPaletteSlots.BlueMagenta20},#8764b8)`,
  BlueMagenta10: `var(${ThemeColorPaletteSlots.BlueMagenta10},#8378de)`,
  Magenta20: `var(${ThemeColorPaletteSlots.Magenta20},#881798)`,
  Magenta10: `var(${ThemeColorPaletteSlots.Magenta10},#c239b3)`,
  MagentaPink20: `var(${ThemeColorPaletteSlots.MagentaPink20},#9b0062)`,
  MagentaPink10: `var(${ThemeColorPaletteSlots.MagentaPink10},#e3008c)`,
  Gray180: `var(${ThemeColorPaletteSlots.Gray180},#252423)`,
  Gray130: `var(${ThemeColorPaletteSlots.Gray130},#605E5C)`,
  Gray100: `var(${ThemeColorPaletteSlots.Gray100},#979593)`,
  Gray50: `var(${ThemeColorPaletteSlots.Gray50},#D2D0CE)`,
  Gray40: `var(${ThemeColorPaletteSlots.Gray40},#393939)`,
  Gray30: `var(${ThemeColorPaletteSlots.Gray30},#7a7574)`,
  Gray20: `var(${ThemeColorPaletteSlots.Gray20},#69797e)`,
  Gray10: `var(${ThemeColorPaletteSlots.Gray10},#a0aeb2)`,
  Gray4: `var(${ThemeColorPaletteSlots.Gray4},#484644)`,
  Gray6: `var(${ThemeColorPaletteSlots.Gray6},#797775)`,
  Gray5: `var(${ThemeColorPaletteSlots.Gray5},#3B3A39)`,
  Gray1: `var(${ThemeColorPaletteSlots.Gray1},#F3F2F1)`
};

export const ThemeColorPalettePresence = {
  Away: `var(${ThemeColorPaletteSlots.Away}, #ffaa44)`,
  DoNotDisturb: `var(${ThemeColorPaletteSlots.DoNotDisturb}, #c50f1f)`,
  Online: `var(${ThemeColorPaletteSlots.Online}, #6bb700)`,
  Invisible: `var(${ThemeColorPaletteSlots.Invisible}, #8a8886)`,
  OutOfOffice: `var(${ThemeColorPaletteSlots.OutOfOffice}, #b4009e)`
};

export const ThemeColorPaletteMessaging = {
  Warning: `var(${ThemeColorPaletteSlots.Warning}, #fff4ce)`,
  WarningIcon: `var(${ThemeColorPaletteSlots.WarningIcon}, #797673)`,
  SeverWarning: `var(${ThemeColorPaletteSlots.SeverWarning}, #fed9cc)`,
  SeverWarningIcon: `var(${ThemeColorPaletteSlots.SeverWarningIcon}, #d83b01)`,
  ErrorBlock: `var(${ThemeColorPaletteSlots.ErrorBlock}, #fde7e9)`,
  ErrorBlockIcon: `var(${ThemeColorPaletteSlots.ErrorBlockIcon}, #a80000)`,
  ErrorBackground: `var(${ThemeColorPaletteSlots.ErrorBackground}, rgba(253, 231, 233, 0.15))`,
  ErrorBoxBackground: `var(${ThemeColorPaletteSlots.ErrorBoxBackground}, #FDE7E9)`,
  ErrorText: `var(${ThemeColorPaletteSlots.ErrorText}, #323130)`,
  InfoText: `var(${ThemeColorPaletteSlots.InfoText}, #323130)`,
  DarkErrorBlock: `var(${ThemeColorPaletteSlots.DarkErrorBlock}, #3E1F25)`,
  DarkGrayErrorBackground: `var(${ThemeColorPaletteSlots.DarkGrayErrorBackground}, #484848)`,
  RedErrorText: `var(${ThemeColorPaletteSlots.RedErrorText}, #F9526B)`,
  GrayIcon: `var(${ThemeColorPaletteSlots.GrayIcon},  #333333)`,
  Success: `var(${ThemeColorPaletteSlots.Success}, #dff6dd)`,
  SuccessIcon: `var(${ThemeColorPaletteSlots.SuccessIcon}, #107c10)`
};

export const ThemeColorPaletteAnnotations = {
  //#region  Proofing
  SuggestionAcceptedBackground: `var(${ThemeColorPaletteSlots.SuggestionAcceptedBackground}, #d4edd4)`,
  SpellingSuggestionHoverHighlight: `var(${ThemeColorPaletteSlots.SpellingSuggestionHoverHighlight}, #fde5e5)`,
  SpellingHoverTextColor: `var(${ThemeColorPaletteSlots.SpellingHoverTextColor}, ${ThemeColorPaletteSlots.neutralPrimary})`,
  GrammarSuggestionHoverHighlight: `var(${ThemeColorPaletteSlots.GrammarSuggestionHoverHighlight}, #eaeeff)`,
  GrammarHoverTextColor: `var(${ThemeColorPaletteSlots.GrammarHoverTextColor}, ${ThemeColorPaletteSlots.neutralPrimary})`,
  RefinementSuggestionHoverHighlight: `var(${ThemeColorPaletteSlots.RefinementSuggestionHoverHighlight}, #e7e4fb)`,
  RefinementHoverTextColor: `var(${ThemeColorPaletteSlots.RefinementHoverTextColor}, ${ThemeColorPaletteSlots.neutralPrimary})`,
  //#endregion
  //#region Entity Recognition
  EntityRecognitionUnderline: `var(${ThemeColorPaletteSlots.EntityRecognitionUnderline}, #484644)`,
  EntityRecognitionHoverHighlight: `var(${ThemeColorPaletteSlots.EntityRecognitionHoverHighlight}, #f3f2f1)`,
  EntityRecognitionHoverTextColor: `var(${ThemeColorPaletteSlots.EntityRecognitionHoverTextColor}, ${ThemeColorPaletteSlots.neutralPrimary})`,
  //#endregion
  //#region Task Recognition
  TaskRecognitionUnderline: `var(${ThemeColorPaletteSlots.TaskRecognitionUnderline}, #484644)`,
  TaskRecognitionHoverHighlight: `var(${ThemeColorPaletteSlots.TaskRecognitionHoverHighlight}, #f3f2f1)`,
  TaskRecognitionHoverTextColor: `var(${ThemeColorPaletteSlots.TaskRecognitionHoverTextColor}, ${ThemeColorPaletteSlots.neutralPrimary})`
  //#endregion
};

export const ThemeColorPalette = {
  Theme: {
    themeDarker: `var(${ThemeColorPaletteSlots.themeDarker}, #792000)`,
    themeDark: `var(${ThemeColorPaletteSlots.themeDark}, #A52C00)`,
    themeDarkAlt: `var(${ThemeColorPaletteSlots.themeDarkAlt}, #C33400)`,
    themePrimary: `var(${ThemeColorPaletteSlots.themePrimary}, #D83B01)`,
    themeSecondary: `var(${ThemeColorPaletteSlots.themeSecondary}, #DD4F1B)`,
    themeTertiary: `var(${ThemeColorPaletteSlots.themeTertiary}, #E8825D)`,
    themeLight: `var(${ThemeColorPaletteSlots.themeLight}, #F4BEAA)`,
    themeLighter: `var(${ThemeColorPaletteSlots.themeLighter}, #F9DCD1)`,
    themeLighterAlt: `var(${ThemeColorPaletteSlots.themeLighterAlt}, #FDF6F3)`
  },
  Neutral: {
    black: `var(${ThemeColorPaletteSlots.black}, #000000)`,
    neutralDark: `var(${ThemeColorPaletteSlots.neutralDark}, #201F1E)`,
    neutralPrimary: `var(${ThemeColorPaletteSlots.neutralPrimary}, #252423)`,
    neutralPrimaryAlt: `var(${ThemeColorPaletteSlots.neutralPrimaryAlt}, #484644)`,
    neutralSecondary: `var(${ThemeColorPaletteSlots.neutralSecondary}, #605E5C)`,
    neutralSecondaryAlt: `var(${ThemeColorPaletteSlots.neutralSecondaryAlt}, #8A8886)`,
    neutralTertiary: `var(${ThemeColorPaletteSlots.neutralTertiary}, #A19F9D)`,
    neutralTertiaryAlt: `var(${ThemeColorPaletteSlots.neutralTertiaryAlt}, #C8C6C4)`,
    neutralQuaternary: `var(${ThemeColorPaletteSlots.neutralQuaternary}, #D2D0CE)`,
    neutralQuaternaryAlt: `var(${ThemeColorPaletteSlots.neutralQuaternaryAlt}, #E1DFDD)`,
    neutralLight: `var(${ThemeColorPaletteSlots.neutralLight}, #EDEBE9)`,
    neutralLighter: `var(${ThemeColorPaletteSlots.neutralLighter}, #F3F2F1)`,
    neutralLighterAlt: `var(${ThemeColorPaletteSlots.neutralLighterAlt}, #FAF9F8)`,
    white: `var(${ThemeColorPaletteSlots.white}, #FFFFFF)`
  },
  Accent: {
    yellowDark: `var(${ThemeColorPaletteSlots.yellowDark}, #d29200)`,
    yellow: `var(${ThemeColorPaletteSlots.yellow}, #ffb900)`,
    yellowLight: `var(${ThemeColorPaletteSlots.yellowLight}, #fff100)`,
    orange: `var(${ThemeColorPaletteSlots.orange}, #d83b01)`,
    orangeLight: `var(${ThemeColorPaletteSlots.orangeLight}, #ea4300)`,
    orangeLighter: `var(${ThemeColorPaletteSlots.orangeLighter}, #ff8c00)`,
    redDark: `var(${ThemeColorPaletteSlots.redDark}, #a4262c)`,
    red: `var(${ThemeColorPaletteSlots.red}, #d13438)`,
    magentaDark: `var(${ThemeColorPaletteSlots.magentaDark}, #5c005c)`,
    magenta: `var(${ThemeColorPaletteSlots.magenta}, #b4009e)`,
    magentaLight: `var(${ThemeColorPaletteSlots.magentaLight}, #e3008c)`,
    purpleDark: `var(${ThemeColorPaletteSlots.purpleDark}, #32145a)`,
    purple: `var(${ThemeColorPaletteSlots.purple}, #5c2d91)`,
    purpleLight: `var(${ThemeColorPaletteSlots.purpleLight}, #b4a0ff)`,
    blueDark: `var(${ThemeColorPaletteSlots.blueDark}, #002050)`,
    blueMid: `var(${ThemeColorPaletteSlots.blueMid}, #00188f)`,
    blue: `var(${ThemeColorPaletteSlots.blue}, #0078d4)`,
    blueLight: `var(${ThemeColorPaletteSlots.blueLight}, #00bcf2)`,
    tealDark: `var(${ThemeColorPaletteSlots.tealDark}, #004b50)`,
    teal: `var(${ThemeColorPaletteSlots.teal}, #008272)`,
    tealLight: `var(${ThemeColorPaletteSlots.tealLight}, #00B294)`,
    greenDark: `var(${ThemeColorPaletteSlots.greenDark}, #004b1c)`,
    green: `var(${ThemeColorPaletteSlots.green}, #107c10)`,
    greenLight: `var(${ThemeColorPaletteSlots.greenLight}, #bad80a)`
  }
};
